import { computed, inject, Injectable } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { ReceiptService } from "@malirang/api-client";
import { CenterStore } from "../../../stores/center/center.store";

@Injectable({ providedIn: "any" })
export class ReceiptFilterStore {
    private readonly receiptService = inject(ReceiptService);
    private readonly centerStore = inject(CenterStore);

    private $items = rxResource({
        stream: ({ params }) =>
            this.receiptService.receiptControllerFindFilter({
                centerId: params.centerId,
            }),
        params: () => ({
            centerId: this.centerStore.currentCenterId(),
        }),
    });

    items = this.$items.value;

    centerUsers = computed(() => this.items()?.centerUsers || []);
    guardians = computed(() => this.items()?.guardians || []);
    ticketTypes = computed(() => this.items()?.ticketTypes || []);
    tickets = computed(() => this.items()?.tickets || []);
    childs = computed(() => this.items()?.childs || []);
    genderOptions = [
        { label: "전체", value: undefined },
        { label: "남자", value: "MALE" },
        { label: "여자", value: "FEMALE" },
    ];
    receiptStatusOptions = [
        { label: "전체", value: undefined },
        { label: "대기", value: "PENDING" },
        { label: "완료", value: "COMPLETED" },
        { label: "환불", value: "REFUND" },
    ];
}
